// Цепочка правок студии /generate: связь «результат → из какого кадра сделан».
//
// «В работу» кладёт фото генерации в слот бара; ближайшая генерация — её
// ПРАВКА (или «оживление» видео-моделью). Тег edit_source_request_id уходит в
// params запроса (ApiClient.request, тем же спредом, что source_style_id) и
// сохраняется навсегда — лента /files отдаёт его карточке, и версии одной
// работы собираются в одну историю без миграций и localStorage.
//
// Семантика ЛИПКАЯ ПО СЛОТУ (не one-shot): тег живёт, пока взятый кадр стоит
// в баре. Каждая генерация с ним — правка этого кадра: ретрай после «не
// хватило токенов» и «Пересоздать» НЕ теряют цепочку (one-shot терял — тег
// съедался неудачной попыткой). Конец жизни тега: кадр покинул слот
// (Generate.tsx чистит по опустевшему слоту) или новое «в работу» его
// перезаписало. Окно неточности одно: юзер вручную ЗАМЕНИЛ фото в слоте —
// тег остаётся от взятого кадра; сценарий экзотический, следующая правка
// перезапишет.

let source: string | null = null

/** «В работу»: запомнить request_id генерации, чьё фото встало в слот. */
export function setEditSource(requestId: string | null): void {
	source = requestId
}

/** Кадр покинул слот — правок больше не будет, тег снимается. */
export function clearEditSource(): void {
	source = null
}

/** Тег для уходящего запроса генерации (НЕ обнуляет — см. шапку). */
export function getEditSource(): string | null {
	return source
}
